/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Launch_Monthly_SignalsInputs */

const en_directory_launch_monthly_signals = /** @type {(inputs: Directory_Launch_Monthly_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monthly Signals`)
};

const zh_directory_launch_monthly_signals = /** @type {(inputs: Directory_Launch_Monthly_SignalsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`月度信号`)
};

/**
* | output |
* | --- |
* | "Monthly Signals" |
*
* @param {Directory_Launch_Monthly_SignalsInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_launch_monthly_signals = /** @type {((inputs?: Directory_Launch_Monthly_SignalsInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Launch_Monthly_SignalsInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_launch_monthly_signals(inputs)
	return zh_directory_launch_monthly_signals(inputs)
});
export { directory_launch_monthly_signals as "directory.launch.monthly_signals" }